import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './i18n';
import { CurrencyProvider } from './currency';
import { CartProvider } from './cart';
import { LayerProvider } from './layers/LayerProvider';
import { FavoritesProvider } from './favorites';
import { RecentlyViewedProvider } from './recentlyViewed';
import { StorefrontProvider } from './storefront/StorefrontContext';
import { PromotionLabelsProvider } from './promotionLabels';
import { CustomerProvider } from './auth/CustomerContext';
import { ConsentProvider } from './tracking/consent';
import { TrackingProvider } from './tracking/TrackingProvider';
import { Layout } from './components/Layout';
import { CatalogPage } from './pages/CatalogPage';
import { ProductPage } from './pages/ProductPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TrackOrderPage } from './pages/TrackOrderPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { ContentPage } from './pages/ContentPage';
import { GlossaryIndexPage } from './pages/GlossaryIndexPage';
import { GlossaryTermPage } from './pages/GlossaryTermPage';
import { SalePage } from './pages/SalePage';
import { ContactPage } from './pages/ContactPage';
import { RegisterPage } from './pages/RegisterPage';
import { AccountPage } from './pages/AccountPage';
import { PartnerPage } from './pages/PartnerPage';
import { RefCapture } from './affiliate/RefCapture';
import { NotFoundPage } from './pages/NotFoundPage';

export function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <CurrencyProvider>
      <StorefrontProvider>
      <CustomerProvider>
      {/* Tracking: consent gate + page_viewed/identify. Pod CustomerProviderem
          (identify potřebuje customer kontext), router je nejvýš, takže
          useLocation uvnitř funguje. */}
      <ConsentProvider>
      <TrackingProvider>
      <FavoritesProvider>
      <RecentlyViewedProvider>
      <CartProvider>
      {/* Stitky akci pro dlazdice – batchujici cache, fail-silent. */}
      <PromotionLabelsProvider>
      {/* Vrstvy (pop-upy/weblayery) nejníž ze všech providerů – potřebují
          router, useCustomer, useConsent i useCart. */}
      <LayerProvider>
        {/* Zachycení partnerského odkazu `?ref=`. Nic nevykresluje; musí být
            uvnitř routeru (čte adresu) i ConsentProvideru (klíč zařízení
            posílá jen se souhlasem s analytikou). */}
        <RefCapture />
        <Layout>
          <Routes>
            <Route path="/" element={<CatalogPage />} />
            <Route path="/produkt/:slug" element={<ProductPage />} />
            <Route path="/kosik" element={<CartPage />} />
            <Route path="/pokladna" element={<CheckoutPage />} />
            <Route path="/hotovo/:orderNumber" element={<ThankYouPage />} />
            <Route path="/objednavka" element={<TrackOrderPage />} />
            <Route path="/oblibene" element={<FavoritesPage />} />
            <Route path="/stranka/:slug" element={<ContentPage />} />
            <Route path="/slovnik" element={<GlossaryIndexPage />} />
            <Route path="/slovnik/:slug" element={<GlossaryTermPage />} />
            <Route path="/akce" element={<SalePage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/registrace" element={<RegisterPage />} />
            <Route path="/ucet" element={<AccountPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            {/* Neznama adresa NENI katalog. Vracet na kazdy preklep
                plnohodnotnou stranku se zbozim znamena pro Google "soft 404";
                stranka se navic jeste zepta, jestli se zbozi jen neprestehovalo. */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </LayerProvider>
      </PromotionLabelsProvider>
      </CartProvider>
      </RecentlyViewedProvider>
      </FavoritesProvider>
      </TrackingProvider>
      </ConsentProvider>
      </CustomerProvider>
      </StorefrontProvider>
      </CurrencyProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
